import React from "react";
import { mediaUrl, mediaSet } from "../../services/api";

/**
 * An uploaded picture delivered the spec 09 way: AVIF, then WebP, then the
 * JPEG/PNG fallback, at the size the slot needs (`sizes`), lazy unless
 * it's the main picture (`priority`), with width and height reserved.
 * Pictures without sized copies render as a plain <img>.
 */
const Picture = ({ src, alt = "", sizes = "100vw", width, height, loading = "lazy", priority = false, className, style, ...rest }) => {
  const set = mediaSet(src);
  const img = (
    <img
      src={mediaUrl(src)}
      alt={alt}
      width={width}
      height={height}
      loading={priority ? "eager" : loading}
      decoding="async"
      {...(priority ? { fetchpriority: "high" } : {})}
      className={className}
      style={style}
      {...rest}
    />
  );
  if (!set) return img;
  return (
    <picture style={{ display: "contents" }}>
      <source type="image/avif" srcSet={set.avif} sizes={sizes} />
      <source type="image/webp" srcSet={set.webp} sizes={sizes} />
      {img}
    </picture>
  );
};

export default Picture;
